// extracted by mini-css-extract-plugin
export var highlightFade = "_3r-4";
export var highlighted = "_3r-3";
export var table = "_3r-1";
export var tableContainer = "_3r-0";
export var totalsRow = "_3r-2";